import api from './api';

export const vendorSettlementApi = {
    async getAll(params?: { page?: number; limit?: number }) {
        const response = await api.get('/vendor/settlements', { params });
        return response.data;
    },

    async getById(id: string) {
        const response = await api.get(`/vendor/settlements/${id}`);
        return response.data;
    },
};
